import * as yup from 'yup';

export const contractUploadDocumentFormValidationSchema = yup.object().shape({
    files: yup
        .array()
        .of(yup.object())
        .test((arr) => arr.length > 0),
});
